import { createPortal } from 'react-dom';

const TutorialDemonstracaoTransitionProcessingHint = () =>
	createPortal(
		<div
			className="pointer-events-none fixed bottom-6 right-6 z-[60] max-w-[300px] rounded-xl border border-zinc-200/90 bg-white px-4 py-3 shadow-2xl"
			role="status"
			aria-live="polite"
		>
			<p className="text-sm leading-snug text-zinc-600">
				A IA está processando as informações da sessão. Logo após o
				pós-processamento, você verá o prontuário pré-preenchido.
			</p>
		</div>,
		document.body,
	);

export { TutorialDemonstracaoTransitionProcessingHint };
